$(function () {
    /*=================================================
    ハンバーガ―メニュー
    ===================================================*/

    $('.hamburger-btn').on('click', function () {
        hamburger();
    });

    $('.hamburger-menu a').on('click', function () {
        closeHamburger();
    });
});

/*=================================================
ハンバーガ―メニュー開閉
===================================================*/
function hamburger() {
    $('.hamburger-btn').toggleClass('active');

    if ($('.hamburger-btn').hasClass('active')) {
        $('.hamburger-menu').addClass('active');
        $('body').addClass('active');
    } else {
        closeHamburger();
    }
}

/*=================================================
ハンバーガ―メニューを閉じる
===================================================*/
function closeHamburger() {
    $('.hamburger-btn').removeClass('active');
    $('.hamburger-menu').removeClass('active');
    $('body').removeClass('active');
}
/*=================================================
スライダー
===================================================*/
$('.movie').each(function () {
    const $wrap = $(this);

    $wrap.find('.slider').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 2.8,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $wrap.find('.prev'),
        nextArrow: $wrap.find('.next'),
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                }
            }
        ]
    });
});

$('.benefit').each(function () {
    const $wrap = $(this);

    $wrap.find('.slider').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 2.8,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $wrap.find('.prev'),
        nextArrow: $wrap.find('.next'),
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                }
            }
        ]
    });
});
$('.history').each(function () {
    const $wrap = $(this);

    $wrap.find('.slider').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 2.9,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: $wrap.find('.prev'),
        nextArrow: $wrap.find('.next'),
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1.3,
                    slidesToScroll: 1,
                }
            }
        ]
    });
});
/*=================================================
動画
===================================================*/
$('.video').on('click', function () {

    $('.video').not(this).each(function () {
        const id = $(this).data('id');
        $(this).html(`
      <img src="https://img.youtube.com/vi/${id}/hqdefault.jpg">
      <div class="play-btn"></div>
    `);
        $(this).removeClass('played');
    });

    if ($(this).hasClass('played')) return;
    $(this).addClass('played');

    const videoId = $(this).data('id');
    $(this).html(`
      <iframe
    src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1"
    frameborder="0"
    allow="autoplay; encrypted-media"
    allowfullscreen>
  </iframe>
  `);
});